import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PopoverCyclecountGeigerPage} from './popover-cyclecount-geiger';
import {ComponentsModule} from "../../components/components.module";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    PopoverCyclecountGeigerPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(PopoverCyclecountGeigerPage),
    TranslateModule.forChild()
  ],
})
export class PopoverCyclecountGeigerPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/popover-cyclecount-geiger/popover-cyclecount-geiger.module.ts